import { MARKETING_TAGS } from '../../../../constants/marketingTags'
import ListingBadge, { BADGE_ORDER_PRIORITY } from './base'
import { hasMarketingTag, isForeclosure } from './utils'

export default class NewlyVacantBadge extends ListingBadge {
  static titleV2 = 'Now Vacant'

  static renderPriorityV2 = listing =>
    isForeclosure(listing)
      ? BADGE_ORDER_PRIORITY.FOURTH
      : BADGE_ORDER_PRIORITY.FIRST

  static shouldBeIncludedV2 = listing =>
    hasMarketingTag(listing, MARKETING_TAGS.NEWV)
}
